export const FOOTER_TEXT = {
    contacts: {title: 'Контакты'},
    hotLine: {title: 'Горячая линия'},
    payments: {title: 'Принимаем к оплате'},
} as const;
